import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./ChargingSlider.module.scss";
import ChargingMethodsCard1 from "../ChargingMethodsCard1/ChargingMethodsCard1";
import ChargingMethodsCard2 from "../ChargingMethodsCard2/ChargingMethodsCard2";
import { Pagination } from "swiper/modules";

export default function ChargingSlider() {
  return (
    <div className={styles.container}>
      <Swiper
        className="chargingMethodsSwiper"
        spaceBetween={40}
		  speed={300}
        slidesPerView={"auto"}
        modules={[Pagination]}
        pagination={{
          type: "bullets",
			 clickable: true,
          el: ".сhargingMethods-paginations",
        }}
        //Костыль с отступами для слайдера
        breakpoints={{
          375: {
            slidesOffsetBefore: 237,
            slidesOffsetAfter: 237,
          },
          575: {
            slidesOffsetBefore: 237,
            slidesOffsetAfter: 237,
          },
          1366: {
            slidesOffsetBefore: 23,
            slidesOffsetAfter: 23,
          },
          1440: {
            slidesOffsetBefore: 60,
            slidesOffsetAfter: 60,
          },
          1536: {
            slidesOffsetBefore: 46,
            slidesOffsetAfter: 46,
          },
          1600: {
            slidesOffsetBefore: 80,
            slidesOffsetAfter: 80,
          },
          1680: {
            slidesOffsetBefore: 120,
            slidesOffsetAfter: 120,
          },
          1728: {
            slidesOffsetBefore: 144,
            slidesOffsetAfter: 144,
          },
          1920: {
            slidesOffsetBefore: 237,
            slidesOffsetAfter: 237,
          },
        }}
      >
        <SwiperSlide>
          <ChargingMethodsCard1 />
        </SwiperSlide>

        <SwiperSlide>
          <ChargingMethodsCard2 />
        </SwiperSlide>
      </Swiper>
      <div className="сhargingMethods-paginations" />
    </div>
  );
}
